import moment from "moment";

export const minutesOfDay = (m) => {
	if (!moment.isMoment(m)) {
		m = moment(m);
	}
	return m.minutes() + m.hours() * 60;
};
